<div style="height: Calc(100vh - 130px);">
  <as-split direction="horizontal" (dragEnd)="dragEnd('pixel', $event)">
    <as-split-area [size]="this.id === 'new' ? 100 : 68">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <h2 class="row" *ngIf="this.rasterUpload">{{ "raster_upload.title" | translate }}</h2>
        <h2 class="row" *ngIf="!this.rasterUpload">{{ "raster.title" | translate }}</h2>
        <div *ngIf="topMenuIcons.length > 0">
          <button mat-raised-button [disabled]="!this.detailForm.valid ||
          !this.selectedCategory ||
          this.selectedCategory.length == 0 ||
          (this.id === 'new' && !this.uploaderService.hasFileLoaded()) " (click)="save()">
            <mat-icon [title]="this.saveIconTitle"> save </mat-icon>
          </button>
          <button mat-raised-button *ngIf="this.id !== 'new' && (this.raster.temporary || this.raster.category.code === this.otherCode) " [disabled]="this.disableByProfile" (click)="deleteConfirm()">
            <mat-icon [title]="this.deleteIconTitle"> delete </mat-icon>
          </button>
          <ng-container *ngFor="let action of topMenuIcons">
            <button mat-raised-button *ngIf="!action.hide" [routerLink]="action.routerLink"
              (click)="this[action.clickMethod]()" >
              <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
            </button>
          </ng-container>
        </div>
      </div>
      <form [formGroup]="detailForm">

        <div fxLayout="row wrap" fxLayoutGap="40px">

          <app-raster-category-dropdown *ngIf="columnsVisible.get('category')"
            (selectedChange)="this.selectedCategory = $event" [ngStyle]="{
          'min-width.px': 275,
          'margin-bottom.px': 15
        }" [required]="true" [singleSelection]="true"
            [selected]="this.raster ? [this.raster.category] : []"></app-raster-category-dropdown>

          <mat-form-field *ngIf="this.id !== 'new' && columnsVisible.get('category_disabled')" [ngStyle]="{
           'width.ch': detailForm.controls['category'].value ? detailForm.controls['category'].value.length : 10,
           'min-width.px': 300
        }">
            <mat-label>{{ "raster.category" | translate }}</mat-label>
            <input matInput [disabled]="true" [ngStyle]="{
            'width.ch': detailForm.controls['category'].value ? detailForm.controls['category'].value.length : 10,
            'min-width.px': 300
        }" />{{ category_disabled }}
          </mat-form-field>

        <mat-checkbox *ngIf="columnsVisible.get('modelCalculation')" [ngStyle]="{
            'width.ch': 10,
            'min-width.px': 120
          }" formControlName="modelCalculation" >{{ "raster.modelCalculation" | translate
          }}</mat-checkbox>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="40px">
          <mat-form-field *ngIf="columnsVisible.get('id')" [ngStyle]="{
                'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
                'min-width.px': 300
              }">
            <mat-label> {{ "raster.id" | translate }} </mat-label>
            <input matInput [ngStyle]="{
                  'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
                  'min-width.px': 300
                }" formControlName="id" />
          </mat-form-field>

          <mat-form-field *ngIf="this.id !== 'new' && columnsVisible.get('originalFileName')" [ngStyle]="{
                'width.ch': detailForm.controls['originalFileName'].value ? detailForm.controls['originalFileName'].value.length : 10,
                'min-width.px': 300
              }">
            <mat-label>{{ "raster.original-filename" | translate }}</mat-label>
            <input matInput class="form-control" [ngStyle]="{
                  'width.ch': detailForm.controls['originalFileName'].value ? detailForm.controls['originalFileName'].value.length : 10,
                  'min-width.px': 300
                }" formControlName="originalFileName" />
            <mat-error *ngIf="detailForm.controls['originalFileName'].errors?.['required']">
              {{ "error.required" | translate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field *ngIf="this.id !== 'new' && columnsVisible.get('created')" [ngStyle]="{
               'width.ch': detailForm.controls['created'].value ? detailForm.controls['created'].value.length : 10,
               'min-width.px': 300
            }">
            <mat-label>{{ "raster.creation-date" | translate }}</mat-label>
            <input matInput [disabled]="true" value="{{ raster.created | date:'yyyy-MM-dd HH:mm' }}"
              class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['created'].value ? detailForm.controls['created'].value.length : 10,
                'min-width.px': 300
            }" />
            <mat-error *ngIf="detailForm.controls['created'].errors?.['required']">
              {{ "error.required" | translate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field *ngIf="this.id !== 'new' && columnsVisible.get('lastModificationDate')" [ngStyle]="{
               'width.ch': detailForm.controls['lastModificationDate'].value ? detailForm.controls['lastModificationDate'].value.length : 10,
               'min-width.px': 300
            }">
            <mat-label>{{ "raster.modification-date" | translate }}</mat-label>
            <input matInput [disabled]="true" value="{{ raster.lastModificationDate | date:'yyyy-MM-dd HH:mm' }}"
              class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['lastModificationDate'].value ? detailForm.controls['lastModificationDate'].value.length : 10,
                'min-width.px': 300
            }" />
            <mat-error *ngIf="detailForm.controls['lastModificationDate'].errors?.['required']">
              {{ "error.required" | translate }}
            </mat-error>
          </mat-form-field>
        </div>



        <div fxLayout="row wrap" fxLayoutGap="40px">
          <mat-checkbox *ngIf="this.id !== 'new' && columnsVisible.get('temporary')" matInput [ngStyle]="{
                          'width.ch': 10,
                            'min-width.px': 80

                        }" formControlName="temporary">{{ "raster.temporary" | translate }}</mat-checkbox>
        </div>


        <div fxLayout="row wrap" class="shapefile-container-50">
          <app-fileuploader-filepond id="childFileUploader" *ngIf="this.id === 'new'" model="raster" summary="Raster: "
           [maxFiles]="1" class="shapefile-container-50">
          </app-fileuploader-filepond>

        </div>


        <div style="margin-top: 15px;margin-bottom: 15px;" [hidden]="this.id === 'new' || !this.raster || (raster && !raster.temporary)">
          <button mat-raised-button (click)="this.mergeRaster()" [disabled]="this.id === 'new'">
            {{ "raster.button-merge" | translate }}
          </button>
        </div>

        <mat-accordion multi>
          <mat-expansion-panel *ngIf="this.id !== 'new'" [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ 'log-messages.title' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
              <mat-panel-description>
            <app-log-messages-list [ngStyle]="{
              'width.pc': 100
            }" [modelId]="this.id"></app-log-messages-list>
            </mat-panel-description>
          </mat-expansion-panel>
        </mat-accordion>
      </form>
    </as-split-area>
    <as-split-area [size]="this.id === 'new' ? 0 : 32">
      <app-map *ngIf="this.id !== 'new'" target="raster-map" [dataPopup]='true'
        [colorMap]="this.colorMap ? this.colorMap : ''" [rastersOnMap]="true"
        [currentCategory]="this.raster && this.raster.category ? this.raster.category.code : undefined"
        [currentCategoryName]="this.raster && this.raster.category ? this.raster.category.name : undefined"
        [lsService]="lsService" [rasterUpload]="this.rasterUpload"></app-map>
    </as-split-area>
  </as-split>
</div>